import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

/* İçerik başlıkları */
const contentFields = [
  { name: "content_1", label: "İçerik" },
  { name: "content_2", label: "Puan 1 (0-20)" },
  { name: "content_3", label: "Puan 2 (21-40)" },
  { name: "content_4", label: "Puan 3 (41-60)" },
  { name: "content_5", label: "Puan 4 (61-80)" },
  { name: "content_6", label: "Puan 5 (81-100)" },
];

const SkillView = () => {
  const { id } = useParams();
  const [skill, setSkill] = useState(null);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/skills/${id}`)
      .then(r => setSkill(r.data))
      .catch(e => console.error("Skill yüklenemedi:", e));
  }, [id]);

  if (!skill) return <p className="text-center mt-4">Yükleniyor…</p>;

  const cover = skill.image ? `${process.env.REACT_APP_API_BASE_URL}${skill.image}` : null;
  const gallery = skill.content_images ? JSON.parse(skill.content_images)[0] : null;

  return (
    <div className="container mt-4">
      <div className="card p-4 shadow-sm">
        <h4 className="fw-bold mb-4 text-primary">{skill.title}</h4>

        <div className="row g-4 mb-4">
          {cover && (
            <div className="col-md-6 text-center">
              <img src={cover} alt="Kapak" className="img-thumbnail" style={{ maxHeight: 180 }} />
              <p className="small text-muted mt-1">Kapak Görseli</p>
            </div>
          )}

          {gallery && (
            <div className="col-md-6 text-center">
              <img
                src={`${process.env.REACT_APP_API_BASE_URL}${gallery}`}
                alt="İçerik Görseli"
                className="img-thumbnail"
                style={{ maxHeight: 180 }}
              />
              <p className="small text-muted mt-1">İçerik Görseli</p>
            </div>
          )}
        </div>

        {contentFields.map(({ name, label }) => (
          skill[name] ? (
            <div className="mb-5" key={name}>
              <h5 style={{ color: "#0d6efd", borderBottom: "1px solid #ccc", paddingBottom: 8 }}>{label}</h5>
              <div
                style={{
                  background: "#fff",
                  border: "1px solid #ddd",
                  padding: "1rem",
                  borderRadius: "0.5rem",
                  lineHeight: 1.7,
                  color: "#333",
                }}
                dangerouslySetInnerHTML={{ __html: skill[name] }}
              />
            </div>
          ) : null
        ))}
      </div>
    </div>
  );
};

export default SkillView;
